export default __webpack_public_path__ + "static/media/backgrounrsignup.00c829a6.jpg";